<template>
  <div class="container-fluid h-100 p-0">
    <!--    <OnboardingTour
          v-if="showTour"
          v-model="showTour"
          @finish="onTourEnd"
        />-->
    <div class="head">
      <div class="col-12 p-0">
        <div class="container-fluid">
          <div class="row pt-2">
            <div class="col-6 col-sm-4">
              <div class=" d-flex">
                <div class="d-lg-none">
                  <el-button :icon="Menu" @click="drawer = true" />
                </div>
                <el-image class="ms-2" style="width: 105px;" src="/img/logo.png" />
                <a
                  href="https://lineon.me"
                  target="_blank"
                  class="ms-3 d-flex align-items-center"
                  style="font-size:12px; font-weight:600; color:var(--ui-color-brand-accent); text-decoration:none; white-space:nowrap;"
                >
                  Главный сайт
                </a>
                <router-link
                  v-if="user?.subscription && (user.subscription.status === 'demo' || user.subscription.days_left <= 7)"
                  to="/billing"
                  class="ms-2 d-flex align-items-center"
                  style="background:var(--cal-warning); color:var(--cal-text-inverse); padding:2px 8px; border-radius:6px; font-size:12px; font-weight:600; white-space:nowrap; cursor:pointer; text-decoration:none;">
                  {{ user.subscription.status === 'demo'
                    ? `Демо: ${user.subscription.days_left} дн.`
                    : `Осталось: ${user.subscription.days_left} дн.` }}
                </router-link>
              </div>
            </div>
            <div class="d-none d-md-block col-5"></div>
            <div class="col-3 text-end pe-5 d-none" v-if="isLogin">
              <el-dropdown>
                <span class="el-dropdown-link">
                  {{ userName }}
                  <el-icon class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="Logout">
                      <font-awesome-icon class="out-icon" :icon="['fas', 'right-from-bracket']" />
                      Выход
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="col-6 col-sm-3 text-end pe-sm-5" v-if="isLogin">
              <div class="user-info">
                <div class="avatar">
                  <div class="avatar-container">
                    <el-upload
                      class="avatar-uploader"
                      action="#"
                      :show-file-list="false"
                      :before-upload="file => beforeAvatarUpload(file)"
                      :http-request="params => handleAvatarUpload(params)">
                      <div class="avatar-hover-container">
                        <el-avatar :src="avaString" :size="40">
                          <template v-if="!avaString">{{ getInitials(userName) }}</template>
                        </el-avatar>
                        <transition name="fade">
                          <div class="avatar-hover-mask">
                            <el-icon class="avatar-hover-icon">
                              <Upload />
                            </el-icon>
                          </div>
                        </transition>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="user-block">
                  <div class="name">{{ userName }}</div>
                  <div class="email">{{ userMail }}</div>
                </div>
                <div class="exit-block">
                  <el-button link @click="Logout">
                    <font-awesome-icon class="out-icon" :icon="['fas', 'right-from-bracket']" />
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-main" :class="{ 'content-main-calendar': $route.path === '/' }" v-if="isLogin">
      <div class="nav-menu d-none d-lg-block">
          <div class="sidebar">
          <div class="menu-top">
            <el-menu
              :default-active="default_active"
              popper-effect="dark"
              active-text-color="var(--ui-color-brand)"
              background-color="var(--ui-color-sidebar-bg)"
              text-color="var(--ui-color-border-soft)"
              class="navigations"
              :key="menuKey">
              <el-menu-item index="1">
                <router-link to="/" class="nav-link">
                  <img src="/img/calendar.svg" alt="Запись" class="menu-icon" />
                  <span>Запись</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="3" v-if="accessibleSections['Расписание']">
                <router-link to="/schedules" class="nav-link">
                  <img src="/img/shifts.svg" alt="Смены" class="menu-icon" />
                  <span>Смены</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="4" v-if="accessibleSections['Контакты']">
                <router-link to="/contacts" class="nav-link">
                  <img src="/img/clients.svg" alt="Клиенты" class="menu-icon" />
                  <span>Клиенты</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="5" v-if="accessibleSections['Абонементы']">
                <router-link to="/certificates" class="nav-link">
                  <img src="/img/cert.svg" alt="Сертификаты" class="menu-icon" />
                  <span>Сертификаты</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="6" v-if="accessibleSections['Транзакции']">
                <router-link to="/client-payments" class="nav-link">
                  <img src="/img/money.svg" alt="Покупки" class="menu-icon" />
                  <span>Покупки</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="7" v-if="accessibleSections['Услуги']">
                <router-link to="/services" class="nav-link">
                  <img src="/img/services.svg" alt="Услуги" class="menu-icon" />
                  <span>Услуги</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="8" v-if="user?.is_admin || user?.permissions === '*'">
                <router-link to="/dialogs" class="nav-link">
                  <el-badge :value="unreadMessage" v-if="unreadMessage > 0">
                    <img src="/img/chat.svg" alt="Чаты" class="menu-icon" />
                  </el-badge>
                  <img v-else src="/img/chat.svg" alt="Чаты" class="menu-icon" />
                  <span>Чаты</span>
                </router-link>
              </el-menu-item>
            </el-menu>
          </div>
          <div class="menu-bottom">

            <el-menu
              :default-active="default_active"
              :collapse="true"
              :show-timeout="100"
              popper-effect="dark"
              active-text-color="var(--ui-color-brand)"
              background-color="var(--ui-color-sidebar-bg)"
              text-color="var(--ui-color-border-soft)"
              class="navigations">
              <el-sub-menu
                index="9"
                class="setting"
                v-if="hasAnySettingsAccess"
                popper-class="settings-popper"
                :popper-offset="10">
                <template #title>
                  <img src="/img/settings.svg" alt="Настройки" class="menu-icon" />
                  <span>Настройки</span>
                </template>
                <el-menu-item-group title="Настройки">
                  <router-link v-if="accessibleSettings.branches" to="/branches" class="nav-link">
                    <el-menu-item index="9-1">Филиалы</el-menu-item>
                  </router-link>
                  <router-link v-if="accessibleSettings.employees" to="/employees" class="nav-link">
                    <el-menu-item index="9-2">Сотрудники</el-menu-item>
                  </router-link>
                  <router-link v-if="accessibleSettings.customFields" to="/custom-fields" class="nav-link">
                    <el-menu-item index="9-3">Пользовательские поля</el-menu-item>
                  </router-link>
                  <router-link v-if="accessibleSettings.messengers" to="/messengers" class="nav-link">
                    <el-menu-item index="9-4">Мессенджеры</el-menu-item>
                  </router-link>
                  <router-link v-if="accessibleSettings.settings" to="/settings" class="nav-link">
                    <el-menu-item index="9-5">Общие</el-menu-item>
                  </router-link>
                  <router-link v-if="accessibleSettings.billing" to="/billing" class="nav-link">
                    <el-menu-item index="9-6">Счёт и оплата</el-menu-item>
                  </router-link>
                </el-menu-item-group>
              </el-sub-menu>
            </el-menu>
          </div>
        </div>
      </div>
      <div class="router-content">
        <router-view />
      </div>
    </div>
    <div class="admin-block" style="height: 100%;" v-else-if="!isLogin && admin">
      <router-view />
    </div>
    <div class="content-main" v-else>
      <router-view
        v-if="$route.path === '/register' || $route.path === '/forgot-password' || $route.path === '/reset-password'" />
      <LoginBlock v-else />
    </div>
  <!-- SUBSCRIPTION EXPIRED OVERLAY -->
  <div
    v-if="isSubscriptionExpired && !isBillingPage"
    class="subscription-overlay">
    <div class="subscription-modal">
      <h2>Подписка недействительна</h2>
      <p>Срок действия вашей подписки истёк.</p>
      <el-button type="primary" size="large" @click="$router.push('/billing')">
        Перейти к оплате
      </el-button>
    </div>
  </div>
  </div>
  <el-drawer v-model="drawer" direction="ltr" title="Навигация" :with-header="false">
    <div class="h-100 position-relative">
      <el-menu
        :default-active="default_active"
        :show-timeout="100"
        popper-effect="dark"
        active-text-color="var(--cal-accent)"
        background-color="var(--cal-bg-panel)"
        text-color="var(--cal-text-regular)"
        class="navigations"
        :key="menuKey"
        :collapse="false">
        <el-menu-item index="1">
          <router-link to="/" class="nav-link">
            <img src="/img/calendar.svg" alt="Запись" class="menu-icon" />
            <span>Запись</span>
          </router-link>
        </el-menu-item>
        <el-menu-item index="3" v-if="accessibleSections['Расписание']">
          <router-link to="/schedules" class="nav-link">
            <img src="/img/shifts.svg" alt="Смены" class="menu-icon" />
            <span>Смены</span>
          </router-link>
        </el-menu-item>
        <el-menu-item index="4" v-if="accessibleSections['Контакты']">
          <router-link to="/contacts" class="nav-link">
            <img src="/img/clients.svg" alt="Клиенты" class="menu-icon" />
            <span>Клиенты</span>
          </router-link>
        </el-menu-item>
        <el-menu-item index="5" v-if="accessibleSections['Абонементы']">
          <router-link to="/certificates" class="nav-link">
            <img src="/img/cert.svg" alt="Сертификаты" class="menu-icon" />
            <span>Сертификаты</span>
          </router-link>
        </el-menu-item>
        <el-menu-item index="6" v-if="accessibleSections['Транзакции']">
          <router-link to="/client-payments" class="nav-link">
            <img src="/img/money.svg" alt="Покупки" class="menu-icon" />
            <span>Покупки</span>
          </router-link>
        </el-menu-item>
        <el-menu-item index="7" v-if="accessibleSections['Услуги']">
          <router-link to="/services" class="nav-link">
            <img src="/img/services.svg" alt="Услуги" class="menu-icon" />
            <span>Услуги</span>
          </router-link>
        </el-menu-item>

        <el-sub-menu index="9" class="setting" v-if="hasAnySettingsAccess">
          <template #title>
            <img src="/img/settings.svg" alt="Настройки" class="menu-icon" />
            <span>Настройки</span>
          </template>
          <el-menu-item-group title="Настройки">
            <router-link v-if="accessibleSettings.branches" to="/branches" class="nav-link">
              <el-menu-item index="1-1">Филиалы</el-menu-item>
            </router-link>
            <router-link v-if="accessibleSettings.employees" to="/employees" class="nav-link">
              <el-menu-item index="1-2">Сотрудники</el-menu-item>
            </router-link>
            <router-link v-if="accessibleSettings.customFields" to="/custom-fields" class="nav-link">
              <el-menu-item index="1-4">Пользовательские поля</el-menu-item>
            </router-link>
            <router-link v-if="accessibleSettings.messengers" to="/messengers" class="nav-link">
              <el-menu-item index="1-5">Мессенджеры</el-menu-item>
            </router-link>
            <router-link v-if="accessibleSettings.settings" to="/settings" class="nav-link">
              <el-menu-item index="1-6">Настройки</el-menu-item>
            </router-link>
            <router-link v-if="accessibleSettings.billing" to="/billing" class="nav-link">
              <el-menu-item index="1-7">Счёт и оплата</el-menu-item>
            </router-link>
          </el-menu-item-group>
        </el-sub-menu>
      </el-menu>
    </div>
  </el-drawer>
</template>
<script>
import { useCookies } from 'vue3-cookies'
import store from '@/components/store/store'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ArrowDown, Menu, Upload } from '@element-plus/icons-vue'
import LoginBlock from '@/components/LoginBlock.vue'
import { ElMessageBox } from 'element-plus'
import { mapActions, mapGetters, mapState } from 'vuex'
import { canAccessSection, permissionGroups } from '@/components/util/accessHelper'

export default {
  name: 'App',
  data() {
    return {
      default_active: null,
      drawer: false,
      admin: false,
      client: '',
      menuKey: 0,
      showTour: false
    }
  },
  async created() {
    const urlParams = new URLSearchParams(window.location.search)
    const ref = urlParams.get('ref')

    console.log(ref);

    if (ref) {
      const { cookies } = useCookies()
      cookies.set('referral_code', ref, '30d')
    }

    const path = window.location.pathname
    this.setActiveFromPath(path)

    if (path === '/adminAmogen') {
      this.admin = true
    }
  },
  computed: {
    accessibleSections() {
      const access = {}
      for (const sectionName of Object.keys(permissionGroups)) {
        access[sectionName] = canAccessSection(sectionName)
      }
      return access
    },
    accessibleSettings() {
      return {
        branches: canAccessSection('Локации'),
        employees: canAccessSection('Сотрудники'),
        customFields: canAccessSection('Сотрудники') || canAccessSection('Локации'),
        messengers: this.user?.is_admin || this.user?.permissions === '*',
        settings: canAccessSection('Локации'),
        billing: this.user?.is_admin || this.user?.permissions === '*'
      }
    },
    hasAnySettingsAccess() {
      return Object.values(this.accessibleSettings).some(v => v)
    },
    ...mapGetters('auth', ['isLogin', 'userName', 'avaString', 'userMail', 'userID']),
    ...mapState('auth', ['user']),
    ...mapState('messengers', ['unreadMessage']),
    Menu() {
      return Menu
    },
    isSubscriptionExpired() {
      const sub = this.user?.subscription;
      if (!sub) return false;
      return Number(sub.days_left) <= 0;
    },
    isBillingPage() {
      return this.$route.path.startsWith('/billing')
    }
  },
  setup() {
    const cookies = useCookies(['token'])
    if (cookies.cookies.get('token')) {
      store.dispatch('auth/setIsLogin', true)
      store.dispatch('socket/connect')
    }
  },
  components: { Upload, ArrowDown, LoginBlock, FontAwesomeIcon },
  methods: {
    ...mapActions(['uploadAvatar']),
    setActiveFromPath(path) {
      if (path === '/setting') this.default_active = '5'
      else if (path === '/users') this.default_active = '2'
      else if (path === '/') this.default_active = '1'
      else if (path === '/schedules') this.default_active = '3'
      else if (path === '/contacts') this.default_active = '4'
      else if (path === '/certificates') this.default_active = '5'
      else if (path === '/client-payments') this.default_active = '6'
      else if (path === '/services') this.default_active = '7'
      else if (path === '/dialogs') this.default_active = '8'
      else if (path === '/branches') this.default_active = '9-1'
      else if (path === '/employees') this.default_active = '9-2'
      else if (path === '/custom-fields') this.default_active = '9-3'
      else if (path === '/messengers') this.default_active = '9-4'
      else if (path === '/settings') this.default_active = '9-5'
      else if (path === '/billing') this.default_active = '9-6'
    },
    async handleAvatarUpload(file) {
      const employeeId = this.userID
      await this.$store.dispatch('uploadAvatar', {
        file,
        data: { employeeId }
      })
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) this.$message.error('Можно загружать только изображения!')
      if (!isLt10M) this.$message.error('Размер файла не должен превышать 10 МБ!')
      return isImage && isLt10M
    },
    getInitials(fullName) {
      if (!fullName) return ''
      const parts = fullName.trim().split(' ')
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
    },
    Logout() {
      ElMessageBox.confirm(
        'Вы уверены что хотите выйти?',
        'Внимание',
        {
          confirmButtonText: 'Выход',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }
      )
        .then(() => {
          store.dispatch('auth/revokeUser')
        })
        .catch(() => {
          console.debug('cancel')
        })
    },
    async onTourEnd() {
      await store.dispatch('auth/finishOnboarding')
      this.showTour = false
    }
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        store.dispatch('socket/connect')
        this.setActiveFromPath(this.$route.path)
        this.menuKey++     // форсируем перерисовку меню, чтобы отобразились доступные пункты
      }
    },
    $route(to) {
      this.setActiveFromPath(to.path)
      this.menuKey++
    },
    user(newVal) {
      if (newVal?.is_new_user) {
        this.showTour = true
      }
    }
  }
}
</script>
<style>
.settings-popper {
  left: 80px !important;
  border: none !important;
  background: var(--cal-bg-panel) !important;
  color: var(--cal-text-regular) !important;
}
.settings-popper .el-menu-item {
  align-items: normal;
  justify-content: normal !important;
  flex-direction: column !important;
  padding: 0 var(--el-menu-base-level-padding) !important;
}
.user-info {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .avatar {
    display: flex;
    width: 38px;
    height: 38px;
    background-color: var(--cal-accent-strong);
    border-radius: 50%;
    margin-right: 15px;
    align-items: center;
    justify-content: center;
    color: var(--cal-text-inverse);
  }

  .user-block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .name {
      font-weight: bold;
      color: var(--cal-text-primary);
    }

    .email {
      color: var(--cal-text-muted);
      font-size: 12px;
    }
  }

  .exit-block {
    margin-left: 10px;
  }
}

.out-icon {
  font-size: 18px;
  color: var(--cal-accent);
}

#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--cal-text-regular);
  background: radial-gradient(120% 140% at 0% 0%, #2d2d2d 0%, #0f172a 40%, #05080f 100%);
  min-height: 100vh;
}

#app .common-layout {
  padding: 0 40px;
}

#app .login-name {
  display: flex;
  color: var(--cal-accent);
  cursor: pointer;
  justify-content: flex-end;
  align-items: center;
}

#app .login-name i {
  margin-left: 5px;
}
</style>
<style>
.el-drawer {
  width: 64px !important;

  .el-drawer__body {
    padding: 0 !important;
  }

  .el-sub-menu.setting {
    bottom: 0;
  }
}

.el-upload {
  margin-top: 5px !important;
}

.el-avatar {
  background-color: var(--cal-accent-strong) !important;
}

.el-form-item.is-success .el-input__wrapper {
  color: var(--ui-color-success); /* ярко-зеленый */
  box-shadow: 0 0 0 1px var(--el-color-success) inset
}

.el-form-item.is-success .el-input__validateIcon {
  color: var(--el-color-success);
}

.out-icon {
  margin-right: 4px;
}

.el-sub-menu.setting .el-sub-menu__title {
  justify-content: center;
  flex-direction: column;
  margin-bottom: 13px;
  padding: inherit;
}
</style>

<style scoped>
/* Исправляем позиционирование бейджа */
.menu-top .el-menu-item .el-badge {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

/* Чтобы бейдж не выталкивал иконку вниз */
.menu-top .el-menu-item .el-badge__content.is-fixed {
  transform: translate(6px, -6px) !important;
}

.head {
  display: flex;
  border-bottom: 1px solid var(--cal-border);
  background: linear-gradient(180deg, #071638 0%, #050f28 100%);
  padding-bottom: 8px;
  margin-bottom: -1px;
  min-height: 74px;
}

.content-main {
  position: relative;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  border-right: 1px solid var(--ui-color-border-soft);
  height: calc(100vh - 74px);
  display: flex;
}

.content-main-calendar {
  overflow: hidden;
}

.nav-menu {
  width: 80px;
  height: 100%;
}

.navigations {
  height: 100%;
  border: none;
  width: 100%;
}

.router-content {
  width: 100%;
  height: calc(100vh - 74px);
  margin-top: 1px;
  overflow: hidden;
}

.navbar {
  border-bottom: 1px solid var(--cal-border);
}

.avatar-hover-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  border-radius: 50%;
  overflow: hidden;
}

.avatar-hover-mask {
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: var(--ui-color-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  border-radius: 50%;
  z-index: 1;
}

.avatar-hover-container:hover .avatar-hover-mask {
  opacity: 1;
  pointer-events: auto;
}

.avatar-hover-icon {
  color: var(--ui-color-white);
  font-size: 22px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.fade-enter-to, .fade-leave-from {
  opacity: 1;
}

.sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(180deg, #0d2355 0%, #081534 100%);
  width: 80px;
  border-right: 1px solid #1c3f78;
}

.menu-top {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 10px;
}

.menu-bottom {
  flex: 0 0 auto;
  border-top: 1px solid var(--cal-border-soft);
  margin-top: auto;
  padding-top: 8px;
}

.menu-top::-webkit-scrollbar {
  width: 6px;
}

.menu-top::-webkit-scrollbar-track {
  background: var(--cal-bg-panel);
}

.menu-top::-webkit-scrollbar-thumb {
  background-color: var(--cal-border-soft);
  border-radius: 4px;
}

.menu-top::-webkit-scrollbar-thumb:hover {
  background-color: var(--cal-border);
}

</style>
<style scoped>
.menu-top .el-menu-item .nav-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #8cb1de;
  text-decoration: none;
  text-align: center;
}

.menu-top .el-menu-item .nav-link span {
  margin-top: 8px;
  white-space: normal;
  line-height: 1.1;
  font-size: 11px;
  font-weight: 600;
  color: #d8e8ff;
}

.menu-top .el-menu-item.is-active .nav-link,
.settings-popper .el-menu-item.is-active .nav-link,
.settings-popper .el-menu-item.is-active .nav-link span,
.menu-top .el-menu-item.is-active .nav-link span {
  color: var(--ui-color-brand) !important;
}

.menu-top .el-menu-item:hover .nav-link,
.settings-popper .el-menu-item:hover .nav-link,
.settings-popper .el-menu-item:hover .nav-link span,
.menu-top .el-menu-item:hover .nav-link span {
  color: var(--ui-color-brand);
}

.menu-top .el-menu-item {
  justify-content: center;
  height: 70px;
  transition: all 0.2s;
  padding: 0 !important;
  border-left: 2px solid transparent;
}

.el-sub-menu.setting .fa-gear {
  font-size: 22px !important;
  color: var(--cal-text-regular);
  transition: color 0.2s;
}

.el-sub-menu.setting span {
  margin-top: 8px;
  font-size: 10px;
  line-height: 1.1;
  font-weight: 500;
  visibility: visible !important;
  overflow: visible !important;
  width: auto !important;
}

.el-sub-menu.setting:hover .fa-gear,
.el-sub-menu.setting:hover span,
.el-sub-menu.setting.is-active .fa-gear {
  color: var(--ui-color-brand) !important;
}

.menu-bottom {
  padding-top: 6px;
  padding-bottom: 6px;
}
.menu-icon {
  width: 34px;
  height: 34px;
  filter: brightness(0) invert(1);
  transition: filter 0.2s;
}

.el-menu-item:hover .menu-icon,
.el-menu-item.is-active .menu-icon,
.el-sub-menu.setting.is-active .menu-icon,
.el-sub-menu.setting:hover .menu-icon {
  filter: invert(53%) sepia(90%) saturate(458%) hue-rotate(162deg) brightness(98%) contrast(98%);
}

.menu-top .el-menu-item.is-active {
  background: rgba(53, 104, 187, 0.25) !important;
  border-left-color: #48c9ff;
}


.subscription-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--ui-color-overlay);
  backdrop-filter: blur(2px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subscription-modal {
  background: var(--cal-bg-panel-alt);
  color: var(--cal-text-inverse);
  padding: 35px 50px;
  border-radius: 12px;
  box-shadow: var(--ui-shadow-modal);
  text-align: center;
  max-width: 450px;
}

</style>
